import lStorage from '../store/localStorage';
import store from '../store';
import {rest} from '@/utils/utils';
import router from '.';
import i18n from '@/i18n';

export const ifNotAuthenticated = (to, from, next) => {
    if (!lStorage.get('auth-token')) {
        next();
        return;
    }
    //next("/");
    router.push({
        name:"Home",
        params:{
            locale:to.params.locale,
        }
    });
};

export const ifAuthenticated = (to,from,next) => {
    if(lStorage.get('auth-token')){
        store.commit('loading/is',true);
        
        rest.call("profile",{
            "language":to.params.locale
        }).then((response)=>{
            store.commit('loading/is',false);
            if(response && typeof response.number == "undefined"){
                store.commit('user/set',response);
                next();
            }else{
                lStorage.remove('auth-token');
                //next({path: '/login', query: {from: to.path}});
                router.push({
                    name:"LoginPage",
                    params:{
                        locale:to.params.locale,
                    },
                    query: {
                        from: to.path
                    }
                });
            }
        }).catch((error)=>{
            lStorage.remove('auth-token');
            store.commit('loading/is',false);
            //next({path: '/login', query: {from: to.path}});
            router.push({
                name:"LoginPage",
                params:{
                    locale:to.params.locale,
                },
                query: {
                    from: to.path
                }
            });
        });
    } else {
        lStorage.remove('auth-token');
        //next({path: '/login', query: {from: to.path}});
        router.push({
            name:"LoginPage",
            params:{
                locale:to.params.locale,
            },
            query: {
                from: to.path
            }
        });
    }
};